import {getExpiryDate, setCookie} from '@treatwell/ui';
import {hasCookieConsent} from './hasCookieConsent';

const ORDER_ATTRIBUTION_COOKIE = 'order-attribution';

// A landing with ?utm_source=claude&utm_medium=mcp gives "mcp-claude", kept for 30 days,
// only if the user accepts performance cookies
export const setOrderAttributionCookie = async (href: string) => {
  const params = new URL(href).searchParams;
  const utmSource = params.get('utm_source');
  const utmMedium = params.get('utm_medium');

  if (!utmSource || !utmMedium || !(await hasCookieConsent('performance'))) {
    return;
  }

  setCookie({
    name: ORDER_ATTRIBUTION_COOKIE,
    value: `${utmMedium}-${utmSource}`,
    expires: getExpiryDate(30),
  });
};
